<template>
  <div class="paddingmobile">
    <div class="d-flex justify-center align-center pt-4">
      <v-img
        @click="MIX_go('/home')"
        src="@/assets/Big-Heart-Logo-Red.jpg"
        contain
        class="headericon"
      />
    </div>

    <v-container class="pt-10">
      <div class="introduction">
        <div class="header mb-4 d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <img src="@/assets/icons/togocup_logo.png" />
            <h4 class="title mb-0">{{ $t("togocup") }}</h4>
          </div>
          <v-btn
            v-if="GET_currentUserProfile && (GET_currentUserProfile.level === 'superadmin' || GET_currentUserProfile.level === 'shopadmin')"
            color="primary"
            class="ml-4"
            @click="openAddLocationDialog"
            small
            depressed
          >
            <v-icon left>mdi-plus</v-icon> Add Location
          </v-btn>
        </div>
        <p>{{ $t("togocupinfo") }}</p>
      </div>
      <h4 class="title mb-4">2GoCup</h4>
      <div class="chip-wrapper">
        <div class="chip-location-list">
          <div
            class="chip-location lightgrey"
            v-for="cup in cupLocations"
            :key="cup.id"
            @click="handleCupClick(cup)"
          >
            <ToGoCupCard
              :data="cup"
              @edit="openEditLocationDialog"
              @delete="confirmDeleteLocation"
            />
          </div>
        </div>
        <MapBoxView :locationList="cupLocations" :fly-to="flyToIndex" />
      </div>
    </v-container>
  <AddToGoCupLocationDialog ref="addToGoCupLocationDialog" @location-added="fetchCupLocations" @location-edited="fetchCupLocations" @location-deleted="fetchCupLocations" />
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">{{ $t('confirmdelete') }}</v-card-title>
        <v-card-text>{{ $t('areyousuredelete') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="deleteDialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="red" text @click="deleteLocation">{{ $t('yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToGoCupCard from "@/components/card/ToGoCupCard.vue";
import MapBoxView from "@/components/MapboxView.vue";
import AddToGoCupLocationDialog from "@/components/dialog/AddToGoCupLocationDialog.vue";
// import QrcodeVue from 'qrcode.vue';
export default {
  name: "ToGoCupView",
  components: {
    ToGoCupCard,
    MapBoxView,
    AddToGoCupLocationDialog,
  },
  data: () => ({
    flyToIndex: null,
    showAddLocationDialog: false,
    cupLocations: [],
    deleteDialog: false,
    locationToDelete: null
  }),
  mounted() {
    this.fetchCupLocations();
  },
  methods: {
    async fetchCupLocations() {
      const cupLocationsResults = await this.REDIS_searchFor("togocuplocation", "", "", "", "", "");
      // console.log(cupLocationsResults);
      this.cupLocations = cupLocationsResults.documents;
    },
    handleCupClick(index) {
      this.flyToIndex = [index.loc_long, index.loc_lat];
    },
    openAddLocationDialog() {
      this.$refs.addToGoCupLocationDialog.open();
    },
    openEditLocationDialog(location) {
      this.$refs.addToGoCupLocationDialog.open(location);
    },
    confirmDeleteLocation(location) {
      this.locationToDelete = location;
      this.deleteDialog = true;
    },
    async deleteLocation() {
      if (!this.locationToDelete) return;
      this.deleteDialog = false;
      try {
        await this.REDIS_destroy("togocuplocation", this.locationToDelete.id);
      } catch (e) {
        // console.error("Error deleting location:", e);
      }
      this.locationToDelete = null;
      await this.fetchCupLocations();
    },
  },

  computed: {
    ...mapGetters({
      GET_showDrawer: "GET_showDrawer",
      GET_showFilterDrawer: "GET_showFilterDrawer",
      GET_currentUserProfile: "GET_currentUserProfile",
      GET_authenticated: "GET_authenticated",
    }),
  },
};
</script>

<style>
.noboxshadow {
  box-shadow: none !important;
}

.v-carousel__controls {
  margin-top: 200px !important;
}
</style>
<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  gap: 10px;
  img {
    width: 50px;
  }
}

.chip-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  .chip-location-list {
    height: 500px;
    overflow-y: scroll;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 14px;
    .chip-location {
      margin-right: 5px;
      border-radius: 15px;
      padding: 10px;
    }
  }
}

@media (max-width: 768px) {
  .chip-wrapper {
    flex-direction: column-reverse;
    .chip-location-list {
      width: 100%;
    }
  }
}
</style>
